import { TOGGLE_LOADING, ADD_ERROR, DELETE_ERROR, DELETE_ALL_ERRORS } from './types';

const createReducers = ({ loadingInitialState, errorsInitialState }) => {
  // Loading Reducer
  // Each application's instance of Redux has access to this reducer. It's purpose is to easily
  // determine whether an application is in a loading state at a macro level (see './selectors.js')
  // and at a more granular level, e.g. whether a pv order is pending). The consuming application
  // passes in the initialState of the loading reducer, which is of the shape:
  // {
  //   [LOADER_KEY]: [boolean]
  // }
  const loadingReducer = (state = loadingInitialState, action) => {
    switch (action.type) {
      case TOGGLE_LOADING:
        return { ...state, ...action.payload };
      default:
        return { ...state };
    }
  };

  // Error Reducer
  // A top level reducer used to easily manage the error state of its consuming applications.
  // This reducer writes error messages to the top level of its state, so determining whether
  // the application is in a state of error is simple as checking whether the error object has any
  // properties (see './selectors'). And at the same time, we retain the granularity for specific
  // errors.
  const errorsReducer = (state = errorsInitialState, action) => {
    switch (action.type) {
      case ADD_ERROR:
        return { ...state, ...action.payload };
      case DELETE_ERROR: {
        const newErrorObject = { ...state };
        delete newErrorObject[action.payload];
        return {
          ...newErrorObject,
        };
      }
      case DELETE_ALL_ERRORS:
        return {};
      default:
        return { ...state };
    }
  };
  return {
    loadingReducer,
    errorsReducer,
  };
};

export default createReducers;
